/* Branded pointer: fingertip is the click hotspot; never intercepts input. */
(()=>{
  const source=document.currentScript?.dataset.cursorSrc;
  if(!source)return;
  const capability=matchMedia('(hover: hover) and (pointer: fine)');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const root=document.documentElement;
  const cursor=document.createElement('div');
  cursor.className='gouft-cursor';cursor.setAttribute('aria-hidden','true');
  const glove=new Image(112,112);glove.src=source;glove.alt='';glove.draggable=false;
  cursor.append(glove);
  let ready=false,visible=false,lastX=0,lastY=0;
  function hide(){cursor.hidden=true;root.classList.remove('gouft-cursor-active');visible=false;}
  function nativeTarget(target){return target.closest('textarea, select, input:not([type=radio]):not([type=checkbox]):not([type=submit]):not([type=button]), [contenteditable=true], iframe, video[controls], [disabled], [aria-disabled=true]');}
  function position(event){
    if(!ready||!capability.matches||event.pointerType!=='mouse'||nativeTarget(event.target)){hide();return;}
    // Dialog descendants must remain inside the browser's modal top layer.
    const parent=event.target.closest('dialog[open]')||document.body;
    if(cursor.parentElement!==parent)parent.append(cursor);
    lastX=event.clientX;lastY=event.clientY;
    cursor.style.left=lastX+'px';cursor.style.top=lastY+'px';
    cursor.hidden=false;visible=true;root.classList.add('gouft-cursor-active');
    cursor.classList.toggle('is-link',Boolean(event.target.closest('a,button,label.option,summary,[role=button],input[type=radio],input[type=checkbox]')));
  }
  glove.onload=()=>{ready=true;};glove.onerror=hide;
  if(glove.complete&&glove.naturalWidth)ready=true;
  document.addEventListener('pointermove',position,{passive:true});
  document.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse')hide();else if(visible)cursor.classList.add('is-pressed');},{passive:true});
  document.addEventListener('pointerup',()=>cursor.classList.remove('is-pressed'),{passive:true});
  document.addEventListener('pointerout',e=>{if(!e.relatedTarget)hide();},{passive:true});
  document.addEventListener('keydown',hide,{passive:true});
  document.addEventListener('close',hide,true);
  document.addEventListener('scroll',hide,{passive:true,capture:true});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)hide();});
  window.addEventListener('blur',hide);capability.addEventListener('change',hide);
  reduced.addEventListener('change',()=>cursor.classList.toggle('reduce-motion',reduced.matches));
  cursor.classList.toggle('reduce-motion',reduced.matches);hide();
})();
